// extracted by mini-css-extract-plugin
export default {"Tag":"evE2NKxb"};